export default __webpack_public_path__ + "static/media/staff-training.139e08ef.png";